@charset "UTF-8";

/* projects/shared/src/lib/components/responsive-mat-table/responsive-mat-table.component.scss */
:host {
  display: block;
  width: 100%;
}
.responsive-table-wrapper {
  width: 100%;
  overflow-x: hidden;
}
.table-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 16px;
  min-height: 36px;
  padding: 0 0 8px;
}
.table-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.table-toolbar-pagination {
  display: flex;
  min-width: 0;
  margin-left: auto;
  align-items: center;
  justify-content: flex-end;
}
:host ::ng-deep .table-toolbar-pagination .mat-mdc-paginator {
  --mat-paginator-container-size: 36px;
  --mat-paginator-form-field-container-height: 32px;
  --mat-paginator-form-field-container-vertical-padding: 6px;
  --mat-paginator-page-size-select-width: 64px;
  --mat-paginator-page-size-select-touch-target-height: 36px;
  background: transparent;
}
:host ::ng-deep .table-toolbar-pagination .mat-mdc-paginator-container {
  min-height: 36px;
  padding: 0;
  flex-wrap: nowrap;
}
:host ::ng-deep .table-toolbar-pagination .mat-mdc-paginator-page-size {
  margin-right: 8px;
  align-items: center;
}
:host ::ng-deep .table-toolbar-pagination .mat-mdc-paginator-page-size-label {
  order: 2;
  margin: 0 0 0 2px;
  font-size: 0;
}
:host ::ng-deep .table-toolbar-pagination .mat-mdc-paginator-page-size-label::after {
  content: "por p\e1gina";
  font-size: 12px;
}
:host ::ng-deep .table-toolbar-pagination .mat-mdc-paginator-page-size-select {
  order: 1;
  width: 64px;
  margin: 0;
}
:host ::ng-deep .table-toolbar-pagination .mat-mdc-paginator-range-label {
  margin: 0 8px;
}
:host ::ng-deep .table-toolbar-pagination .mat-mdc-paginator-range-actions .mat-mdc-icon-button {
  width: 36px;
  height: 36px;
  padding: 6px;
  --mat-icon-button-state-layer-size: 36px;
  --mat-icon-button-touch-target-display: none;
}
:host ::ng-deep .table-toolbar-pagination .mat-mdc-paginator-icon {
  width: 20px;
}
.refresh-button {
  width: 36px;
  min-width: 36px;
  height: 36px;
  padding: 0 !important;
  border-radius: 50% !important;
}
.refresh-button mat-icon {
  margin: 0 !important;
}
::ng-deep .responsive-table-column-menu.mat-mdc-menu-panel {
  width: 340px;
  max-width: calc(100vw - 24px) !important;
}
::ng-deep .responsive-table-column-menu .mat-mdc-menu-content {
  padding: 0 !important;
}
.column-picker {
  width: 340px;
  max-width: calc(100vw - 24px);
  box-sizing: border-box;
}
.column-picker-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 12px;
}
.column-picker-header strong {
  font-size: 16px;
}
.column-picker-header span {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
}
.column-search {
  --mat-form-field-container-height: 40px;
  --mat-form-field-container-vertical-padding: 8px;
  width: calc(100% - 32px);
  margin: 0 16px 8px;
}
.column-options {
  max-height: min(420px, 100vh - 260px);
  overflow-y: auto;
  padding: 0 8px 8px;
}
.column-option {
  display: flex;
  min-height: 44px;
  padding: 0 8px;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
}
.column-option:hover {
  background: rgba(0, 0, 0, 0.04);
}
.column-option mat-checkbox {
  flex: 1;
}
.column-drag-handle {
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
  margin-right: 4px;
  color: rgba(0, 0, 0, 0.45);
  cursor: grab;
}
.column-drag-handle:active {
  cursor: grabbing;
}
.cdk-drag-disabled .column-drag-handle {
  color: rgba(0, 0, 0, 0.2);
  cursor: not-allowed;
}
.cdk-drag-preview {
  box-sizing: border-box;
  display: flex;
  min-height: 44px;
  padding: 0 8px;
  align-items: center;
  background: white;
  border-radius: 4px;
  box-shadow:
    0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14),
    0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.cdk-drag-placeholder {
  opacity: 0.25;
}
.cdk-drag-animating,
.column-options.cdk-drop-list-dragging .column-option:not(.cdk-drag-placeholder) {
  transition: transform 180ms cubic-bezier(0, 0, 0.2, 1);
}
.column-option > mat-icon {
  color: rgba(0, 0, 0, 0.45);
  font-size: 18px;
  height: 18px;
  width: 18px;
  margin-right: 8px;
}
.empty-columns {
  color: rgba(0, 0, 0, 0.6);
  padding: 20px 12px;
  text-align: center;
}
.column-picker-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 12px;
}
.mat-header-cell,
.mat-mdc-header-cell {
  justify-content: flex-start !important;
  text-align: left !important;
}
:host ::ng-deep .mat-header-cell .mat-sort-header,
:host ::ng-deep .mat-mdc-header-cell .mat-sort-header {
  width: auto;
}
:host ::ng-deep .mat-header-cell .mat-sort-header-container,
:host ::ng-deep .mat-mdc-header-cell .mat-sort-header-container {
  justify-content: flex-start !important;
}
:host ::ng-deep .mat-header-cell .mat-sort-header-content,
:host ::ng-deep .mat-mdc-header-cell .mat-sort-header-content {
  display: flex;
  justify-content: flex-start !important;
  width: auto;
  text-align: left;
}
:host ::ng-deep .responsive-table-wrapper .mat-mdc-header-cell,
:host ::ng-deep .responsive-table-wrapper .mat-mdc-cell {
  box-sizing: border-box;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
}
:host ::ng-deep .responsive-table-wrapper .mat-mdc-header-cell {
  justify-content: flex-start !important;
}
:host ::ng-deep .responsive-table-wrapper .mat-mdc-header-row {
  border-top: 1px solid var(--mat-table-row-item-outline-color, rgba(0, 0, 0, 0.12)) !important;
  border-bottom: 1px solid var(--mat-table-row-item-outline-color, rgba(0, 0, 0, 0.12)) !important;
}
:host ::ng-deep .responsive-table-wrapper .mat-sort-header-container,
:host ::ng-deep .responsive-table-wrapper .mat-sort-header-content {
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
:host ::ng-deep .responsive-table-wrapper .mat-column-__actions.mat-mdc-header-cell {
  justify-content: flex-start !important;
}
.bulk-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
}
.bulk-toolbar span {
  margin-right: auto;
}
.detail-row {
  min-height: 0;
  height: 0;
  overflow: hidden;
}
:host ::ng-deep .responsive-table-wrapper .mat-mdc-row:not(.detail-row) > .mat-mdc-cell {
  border-bottom-width: 0 !important;
  border-bottom-style: none !important;
}
.detail-row-expanded {
  height: auto;
  min-height: 48px;
}
.detail-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  width: 100%;
  padding: 12px 16px;
  box-sizing: border-box;
}
.detail-field {
  min-width: 0;
}
.detail-field strong {
  display: block;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 3px;
}
:host ::ng-deep .detail-field idba-mat-table-cell,
:host ::ng-deep .detail-field idba-mat-table-cell p,
:host ::ng-deep .detail-field idba-mat-table-cell .currency {
  justify-content: flex-start !important;
  text-align: left !important;
}
.expandable-row {
  cursor: pointer;
}
.mat-column-__selection {
  flex: 0 0 52px;
}
.mat-column-__expand {
  flex: 0 0 48px;
  width: 48px;
  min-width: 48px;
  max-width: 48px;
  padding-left: 4px;
  padding-right: 4px;
}
.mat-column-__actions {
  flex: 0 0 auto;
  width: auto;
  min-width: 0;
  max-width: none;
  box-sizing: border-box;
  padding-left: 16px;
  padding-right: 16px;
  white-space: nowrap;
  overflow: visible;
  gap: 4px;
  flex-wrap: wrap;
  align-content: center;
}
:host ::ng-deep .responsive-table-wrapper .mat-column-__selection {
  flex: 0 0 52px !important;
  width: 52px !important;
  min-width: 52px !important;
  max-width: 52px !important;
  margin-left: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  justify-content: center !important;
  box-sizing: border-box;
}
:host ::ng-deep .responsive-table-wrapper .mat-column-__expand {
  flex: 0 0 48px !important;
  width: 48px !important;
  min-width: 48px !important;
  max-width: 48px !important;
  margin-left: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  justify-content: center !important;
  box-sizing: border-box;
}
.row-action {
  flex: 0 0 auto;
  width: auto;
  min-width: max-content;
  white-space: nowrap;
}
.row-action mat-icon {
  margin-right: 4px;
}
@media (max-width: 959px) {
  .table-toolbar-pagination {
    flex: 1 0 100%;
  }
  .mat-column-__actions {
    padding-left: 8px;
    padding-right: 8px;
  }
  .row-action {
    width: 40px;
    min-width: 40px;
    padding: 0 8px;
  }
  .row-action span {
    display: none;
  }
  .row-action mat-icon {
    margin-right: 0;
  }
}
@media (max-width: 599px) {
  :host ::ng-deep .table-toolbar-pagination .mat-mdc-paginator {
    width: 100%;
    min-width: 0;
  }
  :host ::ng-deep .table-toolbar-pagination .mat-mdc-paginator-container {
    justify-content: flex-end;
  }
}
/*# sourceMappingURL=responsive-mat-table.component.css.map */
